import React from "react";
import { Row, Col, Card, Spin } from "antd";
import _ from "lodash"; // Make sure lodash is installed

const DataGrid = ({ tableData, loading }) => {
	// Group tableData into chunks of 2 items each
	const rows = _.chunk(tableData, 2);

	return (
		<Spin spinning={loading}>
			<div style={{ padding: 16 }}>
				{rows.map((rowItems, rowIndex) => (
					// Set the row to display as flex so that the children can stretch equally
					<Row key={rowIndex} gutter={[16, 16]} style={{ marginBottom: 16, display: "flex" }}>
						{rowItems.map(item => (
							// Each Col is set to flex so its content (Card) can stretch equally
							<Col key={item.name} span={12} style={{ display: "flex" }}>
								<Card
									bordered={false}
									style={{
										width: "100%",
										flex: 1, // makes the card take up the full height of the Col
										background: "#f9f9f9",
										padding: "10px",
										borderRadius: "4px",
										boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
										display: "flex",
										flexDirection: "column",
										justifyContent: "center"
									}}
								>
									<p
										style={{
											margin: 0,
											paddingBottom: 4,
											fontWeight: "bold",
											textTransform: "capitalize"
										}}
									>
										{item.name}
									</p>
									<p style={{ margin: 0, color: "#555" }}>{item.value}</p>
								</Card>
							</Col>
						))}
					</Row>
				))}
			</div>
		</Spin>
	);
};

export default DataGrid;
